import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const FRAGMENTS = {
  TAG: '[data-fragment="CareerPositionType.tag"]',
  ITEM: '[data-fragment="CareerPositionType.item"]'
};


class CareerPositionType extends WebComponent {
  constructor(props) {
    super(props);

    this.object = {};

    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    this.object.targetElement = this.element.querySelector(`#${this.element.dataset.target}`);
    this.on('click', FRAGMENTS.TAG, this.handleClick);
  }

  handleClick() {
    const firstTargetElement = this.object.targetElement.querySelector(FRAGMENTS.ITEM);
    firstTargetElement.focus();
  }
}

export default CareerPositionType;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CareerPositionType.js